export default __webpack_public_path__ + "static/media/taurus.25385869.png";